// extracted by mini-css-extract-plugin
export default {"modalArea":"MegaMenu_modalArea__PggL1","modalArea__loader":"MegaMenu_modalArea__loader__hNlLK","modalArea__services":"MegaMenu_modalArea__services__4-52I"};